import React from "react";
import DocumentWaitSvg from "../../assets/svgicons/documents_wait_icon.svg";

const DocumentsWaitIcon = (props) => {
  return <img src={DocumentWaitSvg} alt="Document Info" width="310" />;
};

export default DocumentsWaitIcon;
